<div class="w-100 float-left text-13x">
    <div class="w-100 float-left">
        <div class="w-100 float-left">
            <div class="w-100 float-left mb-3 hidden-actions">
                <div class="float-left text-center">
                    <i class="fa float-left mr-3 text-20x" *ngIf="hasChilds()"
                       [ngClass]="showChild ? 'fa-caret-down' : 'fa-caret-right'"
                       (click)=toggleChild();></i>
                </div>
                <div class="float-left text-center">
                    <div class="checkbox checkbox-primary">
                        <input [id]="i" type="checkbox" (change)="checkIfAllSelected(operation,$event.target.checked)"
                               [(ngModel)]="operation.assigned">
                        <label [for]="i" class="mb-0"></label>
                    </div>
                </div>
                <div class="float-left text-center">
                    <label for="user1" class="mb-md-0 float-left mr-2 mt-1"></label>
                    <p class="float-left text-14x m-0 "> {{ operation.operation | translate }}</p>
                </div>
            </div>
            <child-operations [childOperation]="operation.childOperations"
                              *ngIf="operation.childOperations && showChild"
                              (selected)="select($event)"></child-operations>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/tools/rolesAndPermission/operationComponent.html